import { SAVE_GIFT_CODE } from "./actionTypes";

export default (payload) => ({
  type: SAVE_GIFT_CODE,
  payload: {
    ...payload
  }
});